
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11708',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11708",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.452",
  "dashboard-client-types": "static-1.269",
  "data-fetching-client": "static-1.9527",
  "foundations-components": "static-1.7623",
  "foundations-components-legacy": "static-1.648",
  "foundations-theming": "static-1.4262",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7856",
  "hub-http-shared-msw-handlers": "static-1.9594",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11292",
  "I18n": "static-7.1585",
  "jasmine-runner": "static-1.6320",
  "marketplace-storefront-base": "static-1.11768",
  "quartz": "static-1.6799",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16500",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2713",
  "reporting-testing-lib": "static-1.8663",
  "settings-ui-lib": "static-1.12373",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6831",
  "ui-addon-i18n": "static-1.10994",
  "ui-addon-react-router-dom": "static-1.9395",
  "unified-auth": "static-1.283",
  "unified-auth-core-lib": "static-1.564",
  "usage-tracker": "static-1.7185",
  "usage-tracker-core": "static-1.7035",
  "customer-data-property-utils": "static-1.7930",
  "history": "static-4.47",
  "hub-http": "static-1.6067",
  "integrations-lib": "static-1.15584",
  "marketplace-ui-common": "static-1.19088",
  "property-management-iframe": "static-1.12546",
  "quartz-config": "static-1.577",
  "quartz-core": "static-1.6018",
  "quartz-routing": "static-1.229",
  "quick-fetch": "static-1.3784",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4488",
  "ts-schema": "static-1.3951",
  "ui-universal-auth": "static-1.8769",
  "UIComponents": "static-3.8239",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3275",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3076",
  "quartz-webpack": "static-1.3023",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3892",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4690",
  "foundations-theming-specialty": "static-1.1978",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9276",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5220",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1350",
  "ui-fonts": "static-1.554",
  "ui-images": "static-2.1110",
  "bend-plugin-foundations-theming": "static-1.2745",
  "foundations-theming-base": "static-1.3247",
  "stylex": "static-1.28",
  "HeadJS": "static-2.723",
  "hs-test-utils-bend-plugin": "static-1.2967",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4176",
  "ai-components-ui-library": "static-1.8493",
  "ai-rendering-library": "static-1.9463",
  "chirp-fetch": "static-1.1733",
  "connections-embed-lib": "static-1.710",
  "copilot-toolkit": "static-1.10662",
  "laboratory-lib": "static-3.7009",
  "marketplace-embed": "static-1.21604",
  "marketplace-ui-details": "static-1.8984",
  "marketplace-ui-reviews": "static-1.19044",
  "marketplace-ui-tracking": "static-1.13259",
  "sanitize-text": "static-1.7995",
  "ui-addon-video-player": "static-1.8546",
  "usage-tracker-multi": "static-1.5599",
  "usage-tracker-session-replay": "static-1.4871",
  "wootric-nps": "static-1.6832",
  "apollo-link-hub-http": "static-2.4501",
  "immer": "static-1.33",
  "immerable": "static-1.4004",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2394",
  "reporting-data": "static-1.66730",
  "cssUtils": "static-1.750",
  "flux-actions": "static-1.316",
  "HubStyle": "static-2.11600",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10061",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10223",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7175",
  "icons": "static-2.630",
  "marketplace-ui-apps-core": "static-1.17621",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4370",
  "foundations-components-test-utils": "static-1.5106",
  "quartz-i18n": "static-1.474",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3580",
  "customer-data-objects": "static-1.7501",
  "property-translator": "static-1.5260",
  "frontend-preferences-client": "static-1.7774",
  "hs-promise-utils": "static-1.5443",
  "hubspot-apollo-client": "static-1.4729",
  "integrations-error-boundary-lib": "static-1.12999",
  "integrations-tracking-lib": "static-1.5440",
  "native-integrations-shared-strings": "static-1.7637",
  "reselect": "static-2.16",
  "sanitize": "static-1.4324",
  "superstore": "static-1.4619",
  "ui-shepherd-react": "static-3.9996",
  "ai-settings-ui-library": "static-1.7606",
  "hub-http-janus": "static-1.808",
  "hubspotter-http": "static-1.4524",
  "immutable-less": "static-1.4504",
  "marketplace-ui-client-types": "static-1.16495",
  "nav-meta": "static-1.29074",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10092",
  "ui-addon-upgrades": "static-9.17731",
  "inbound-db-properties-service-client": "static-1.3717",
  "property-management-common": "static-1.4833",
  "ui-addon-iframeable": "static-1.8897",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.498",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.474",
  "quartz-head": "static-1.464",
  "quartz-test": "static-1.474",
  "quartz-tracking": "static-1.178",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2992",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20535",
  "ContentUtils": "static-1.67776",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2342",
  "customer-data-filters-ui": "static-1.39080",
  "customer-data-objects-ui-components": "static-1.12862",
  "customer-data-reference-ui-components": "static-1.12998",
  "embedded-academy-lib": "static-1.13731",
  "ExportDialog": "static-6.10237",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40784",
  "reporting-snowflake": "static-1.55348",
  "reporting-ui-components": "static-2.64001",
  "reporting-visualizations": "static-1.58806",
  "ui-addon-teams": "static-1.21311",
  "magpie-lib": "static-1.5444",
  "magpie-types": "static-1.4904",
  "simple-logging-lib": "static-1.2900",
  "navigation-components": "static-1.17437",
  "ai-studio-lib": "static-1.11131",
  "app-governance-lib": "static-1.1023",
  "developer-experience-shared-components": "static-1.10349",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7841",
  "ui-product-approvals": "static-1.27608",
  "ui-tool-access": "static-1.9994",
  "usage-based-billing-components-lib": "static-1.8149",
  "usage-tracker-anonymous": "static-1.5602",
  "usage-tracker-public": "static-1.6996",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3466",
  "persist-promise": "static-1.3558",
  "reference-resolvers": "static-1.8013",
  "ui-extensibility-client-types": "static-1.3791",
  "hubspot-apollo-cache": "static-1.188",
  "universal-page-editor-lib": "static-1.2851",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2318",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4920",
  "purchase-motions-components": "static-1.5555",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1401",
  "crm-component-utils": "static-1.38599",
  "crm-properties-common-lib": "static-1.5723",
  "customer-data-properties": "static-1.50925",
  "framework-data-schema-resolvers": "static-1.6723",
  "property-value-citations": "static-1.1539",
  "reference-resolvers-lite": "static-1.7933",
  "navigation-messaging": "static-1.6764",
  "hubspotter-http-shared-msw-handlers": "static-1.9592",
  "cms-field-types": "static-1.4659",
  "content-icons-ui": "static-1.2174",
  "conversations-skeleton-state": "static-1.7098",
  "crm-message-bus": "static-1.42512",
  "customer-data-filters-ui-msw-helpers": "static-1.21515",
  "customer-data-ui-utilities": "static-1.9674",
  "FormUrlGenerator": "static-2.4571",
  "framework-builder-read-service-client": "static-1.3879",
  "framework-data-schema-quick-fetch": "static-1.6628",
  "multi-account-reference-resolvers": "static-1.825",
  "onboarding-tours": "static-1.16336",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13201",
  "academy-common-lib": "static-1.13191",
  "content-assistance-lib": "static-1.7521",
  "dashboard-lib": "static-1.80831",
  "file-manager-components": "static-1.23050",
  "getting-started-shared-tasks": "static-1.18020",
  "hubspot-prosemirror": "static-1.17740",
  "hubspot-prosemirror-plugins": "static-1.17732",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19557",
  "share-with-third-party-component-lib": "static-1.8543",
  "ui-addon-draggable": "static-3.4617",
  "ui-asset-management-lib": "static-1.10779",
  "ui-business-units-lib": "static-1.8882",
  "user-context": "static-1.4950",
  "growth-payments-core": "static-1.24868",
  "reporting-plugins": "static-1.10040",
  "reporting-reports": "static-1.66408",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.575",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28966",
  "react-codemirror": "static-1.10476",
  "framework-listing-lib": "static-2-rr-react-compiler.25",
  "fuzzy": "static-1.8",
  "apps-service-types": "static-1.3727",
  "oauth-service-types": "static-1.4097",
  "onboarding-scopes": "static-1.6313",
  "onboarding-tours-client": "static-1.4550",
  "platform-infra-nav-components": "static-1.7538",
  "subscription-experience-data-types": "static-1.14650",
  "crm-record-cards-service-types": "static-1.3488",
  "location-customization-utils-lib": "static-1.8723",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4349",
  "nav-client-types": "static-1.2207",
  "purchase-motions-api": "static-1.5558",
  "signup-constants": "static-1.18512",
  "signup-ui-url-generator": "static-2.7884",
  "trials-service-types": "static-1.3750",
  "card-properties-lib": "static-1.43665",
  "commerce-subscription-lib": "static-1.36601",
  "crm-actions": "static-1.6157",
  "crm-cards-sdk": "static-1.43069",
  "customer-data-properties-shared-msw-handlers": "static-1.8921",
  "customer-data-tracking": "static-1.6732",
  "hs-entities": "static-1.533",
  "pulse": "static-1.371",
  "calling-global-api": "static-1.63866",
  "calling-internal-common": "static-1.31149",
  "calling-lifecycle-internal": "static-1.65248",
  "calling-lifecycle-messages": "static-1.57542",
  "commerce-products-lib": "static-1.8988",
  "conditional-properties-service-client": "static-1.3669",
  "crm-links": "static-1.6118",
  "external-options-client-types": "static-1.4030",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4094",
  "meetings-icalendar-utils-lib": "static-1.482",
  "multi-currency-client-types": "static-1.3562",
  "object-builder-ui-client": "static-1.48164",
  "pipeline-validation-client-types": "static-1.3835",
  "smart-property-lib": "static-1.6129",
  "tiered-pricing": "static-1.907",
  "ui-addon-form-validation": "static-1.10843",
  "crm-pipelines-api-client-types": "static-1.4011",
  "customer-data-associations": "static-1.7173",
  "customer-data-views-management": "static-1.25094",
  "framework-data-table": "static-2.11535",
  "marketing-platform-lib": "static-1.6694",
  "nudge-client-utils": "static-1.2264",
  "nudge-custom-ui-functions": "static-1.770",
  "react-dnd-compat": "static-1.4470",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5209",
  "growth-onboarding-confetti": "static-1.2922",
  "growth-onboarding-next-action-utils": "static-1.1426",
  "onboarding-tours-utils": "static-1.402",
  "ui-shepherd-tracker": "static-1.7377",
  "academy-service-client": "static-1.3530",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28076",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8233",
  "video-components-external": "static-1.10726",
  "video-data-lib": "static-1.34384",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8409",
  "payment-link-components": "static-1.23071",
  "ui-addon-emoji-picker": "static-1.9737",
  "EmailSignatureEditor": "static-1.23991",
  "viral-links-lib": "static-1.6888",
  "data-token-picker": "static-1.16128",
  "FileManagerLib": "static-1.38690",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5094",
  "getting-started-shared-tasks-store": "static-1.17138",
  "campaign-roi-lib": "static-1.8431",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.242",
  "eligibility-engine-service-types": "static-1.3031",
  "crm_data": "static-4.91410",
  "customer-data-sidebar": "static-2.45549",
  "enrichment-properties-lib": "static-1.15247",
  "commerce-billing-lib": "static-1.18629",
  "commerce-shared-components-lib": "static-1.18085",
  "commerce-tools-ui-lib": "static-1.9921",
  "crm-fe-perf": "static-1.22755",
  "directed-graph": "static-1.789",
  "event-emitter": "static-1.797",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31155",
  "shared-worker-versioning": "static-1.10889",
  "calling-usage-tracker": "static-1.6391",
  "voice-sms-access-library": "static-1.392",
  "commerce-permissions": "static-1.613",
  "products-iframe-lib": "static-1.7463",
  "products-ui-components-shared-msw-handlers": "static-1.9976",
  "breeze-intelligence-kit": "static-1.5395",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9677",
  "policy-lib": "static-1.6627",
  "react-tinymce": "static-1.54761",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9740",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53887",
  "tinymce-plugins": "static-1.57001",
  "tinymce-themes": "static-1.55857",
  "crm-export-dialog": "static-1.6142",
  "crm-index-associations-lib": "static-1.6285",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1444",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2021",
  "nudge-renderer-utils": "static-1.2340",
  "whisper-core-api": "static-1.6132",
  "InboxConnectUtils": "static-4.14352",
  "growth-onboarding-next-action-components": "static-1.1454",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6431",
  "content-media-composition-data-lib": "static-1.11649",
  "content-media-compositions": "static-2.15656",
  "media-bridge-lib": "static-1.18650",
  "commerce-tours-lib": "static-1.5798",
  "growth-onboarding-reliability": "static-1.4936",
  "sales-checkout-service-client": "static-1.3517",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21393",
  "sales-email-signature-service-client": "static-1.3693",
  "audio-components": "static-1.5685",
  "FileManagerCore": "static-1.38549",
  "FileManagerImages": "static-1.36201",
  "video-components": "static-1.12729",
  "crm_universal": "static-1.21744",
  "customer-data-email": "static-1.17755",
  "card-payment-highlight-lib": "static-1.36653",
  "card-subscription-highlight-lib": "static-1.39024",
  "commerce-contract-lib": "static-1.11380",
  "customer-data-content": "static-1.26966",
  "invoices-highlight-card-lib": "static-1.54188",
  "orders-highlight-card-lib": "static-1.20996",
  "products-highlight-card-lib": "static-1.17272",
  "project-storage": "static-1.4583",
  "quotes-highlight-card-lib": "static-1.71364",
  "crm-source-interpretation-lib": "static-1.5181",
  "utility-belt": "static-1.2390",
  "payments-enrollment-embed-lib": "static-1.22150",
  "customer-data-rte": "static-1.32566",
  "cv-backend-services": "static-1.1516",
  "growth-onboarding-empty-states": "static-1.5441",
  "payments-post-enroll-local-storage-lib": "static-1.4964",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37454",
  "calling-orchestration-schema": "static-1.35169",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2893",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39972",
  "ui-addon-sales-email": "static-1.5064",
  "layout-dnd-components": "static-1.12135",
  "layout-dnd-utils": "static-1.11110",
  "ui-brand-identity-lib": "static-1.14242",
  "NamespacedHubStyle": "static-2.8942",
  "deal-intel-utils": "static-1.1448",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4381",
  "video-embed": "static-1.35218",
  "social-insights-client-types": "static-1.21509",
  "sequences-lib": "static-1.7767",
  "ui-gdpr-components": "static-1.10197",
  "products-ui-components": "static-1.39507",
  "quotes-ui-lib": "static-1.80085",
  "SalesContentIndexUI": "static-3.8980",
  "accounting-integrations-ui-components": "static-1.6806",
  "invoices-ui-lib": "static-1.54204",
  "commerce-products-api": "static-1.2033",
  "SafeStorage": "static-1.4252",
  "invoices-iframe-lib": "static-1.56262",
  "quotes-modal-lib": "static-1.102042",
  "stripe-embedded-components": "static-1.7223",
  "draft-content-plugins": "static-1.27834",
  "ContentData": "static-1.67851",
  "layout-data-lib": "static-1.9435",
  "outpost": "static-1.4050",
  "sequences-client-types-lib": "static-1.7624",
  "commerce-tax-lib": "static-1.367",
  "property-description-translator": "static-1.3706",
  "FireAlarmUi": "static-1.4379",
  "sales-templates-service-types-lib": "static-1.4038",
  "commerce-analytics-service-client": "static-1.3505",
  "totals-ui-components": "static-1.23122",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14890",
  "advanced-menus-lib": "static-1.11859",
  "ui-memberships-settings-lib": "static-1.33583",
  "commerce-totals-service-types": "static-1.3687",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14889",
  "simple-menus-lib": "static-1.16406"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11708",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.452",
  "dashboard-client-types": "/dashboard-client-types/static-1.269",
  "data-fetching-client": "/data-fetching-client/static-1.9527",
  "foundations-components": "/foundations-components/static-1.7623",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.648",
  "foundations-theming": "/foundations-theming/static-1.4262",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7856",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9594",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11292",
  "I18n": "/I18n/static-7.1585",
  "jasmine-runner": "/jasmine-runner/static-1.6320",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11768",
  "quartz": "/quartz/static-1.6799",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16500",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2713",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8663",
  "settings-ui-lib": "/settings-ui-lib/static-1.12373",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6831",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10994",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9395",
  "unified-auth": "/unified-auth/static-1.283",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.564",
  "usage-tracker": "/usage-tracker/static-1.7185",
  "usage-tracker-core": "/usage-tracker-core/static-1.7035",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7930",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6067",
  "integrations-lib": "/integrations-lib/static-1.15584",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19088",
  "property-management-iframe": "/property-management-iframe/static-1.12546",
  "quartz-config": "/quartz-config/static-1.577",
  "quartz-core": "/quartz-core/static-1.6018",
  "quartz-routing": "/quartz-routing/static-1.229",
  "quick-fetch": "/quick-fetch/static-1.3784",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4488",
  "ts-schema": "/ts-schema/static-1.3951",
  "ui-universal-auth": "/ui-universal-auth/static-1.8769",
  "UIComponents": "/UIComponents/static-3.8239",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3275",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3076",
  "quartz-webpack": "/quartz-webpack/static-1.3023",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3892",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4690",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1978",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9276",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5220",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1350",
  "ui-fonts": "/ui-fonts/static-1.554",
  "ui-images": "/ui-images/static-2.1110",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2745",
  "foundations-theming-base": "/foundations-theming-base/static-1.3247",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.723",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2967",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4176",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8493",
  "ai-rendering-library": "/ai-rendering-library/static-1.9463",
  "chirp-fetch": "/chirp-fetch/static-1.1733",
  "connections-embed-lib": "/connections-embed-lib/static-1.710",
  "copilot-toolkit": "/copilot-toolkit/static-1.10662",
  "laboratory-lib": "/laboratory-lib/static-3.7009",
  "marketplace-embed": "/marketplace-embed/static-1.21604",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8984",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19044",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13259",
  "sanitize-text": "/sanitize-text/static-1.7995",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8546",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5599",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4871",
  "wootric-nps": "/wootric-nps/static-1.6832",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4501",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4004",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2394",
  "reporting-data": "/reporting-data/static-1.66730",
  "cssUtils": "/cssUtils/static-1.750",
  "flux-actions": "/flux-actions/static-1.316",
  "HubStyle": "/HubStyle/static-2.11600",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10061",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10223",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7175",
  "icons": "/icons/static-2.630",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17621",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4370",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5106",
  "quartz-i18n": "/quartz-i18n/static-1.474",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3580",
  "customer-data-objects": "/customer-data-objects/static-1.7501",
  "property-translator": "/property-translator/static-1.5260",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7774",
  "hs-promise-utils": "/hs-promise-utils/static-1.5443",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4729",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12999",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5440",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7637",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4324",
  "superstore": "/superstore/static-1.4619",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9996",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7606",
  "hub-http-janus": "/hub-http-janus/static-1.808",
  "hubspotter-http": "/hubspotter-http/static-1.4524",
  "immutable-less": "/immutable-less/static-1.4504",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16495",
  "nav-meta": "/nav-meta/static-1.29074",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10092",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17731",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3717",
  "property-management-common": "/property-management-common/static-1.4833",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8897",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.498",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.474",
  "quartz-head": "/quartz-head/static-1.464",
  "quartz-test": "/quartz-test/static-1.474",
  "quartz-tracking": "/quartz-tracking/static-1.178",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20535",
  "ContentUtils": "/ContentUtils/static-1.67776",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2342",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39080",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12862",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12998",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13731",
  "ExportDialog": "/ExportDialog/static-6.10237",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40784",
  "reporting-snowflake": "/reporting-snowflake/static-1.55348",
  "reporting-ui-components": "/reporting-ui-components/static-2.64001",
  "reporting-visualizations": "/reporting-visualizations/static-1.58806",
  "ui-addon-teams": "/ui-addon-teams/static-1.21311",
  "magpie-lib": "/magpie-lib/static-1.5444",
  "magpie-types": "/magpie-types/static-1.4904",
  "simple-logging-lib": "/simple-logging-lib/static-1.2900",
  "navigation-components": "/navigation-components/static-1.17437",
  "ai-studio-lib": "/ai-studio-lib/static-1.11131",
  "app-governance-lib": "/app-governance-lib/static-1.1023",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10349",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7841",
  "ui-product-approvals": "/ui-product-approvals/static-1.27608",
  "ui-tool-access": "/ui-tool-access/static-1.9994",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8149",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5602",
  "usage-tracker-public": "/usage-tracker-public/static-1.6996",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3466",
  "persist-promise": "/persist-promise/static-1.3558",
  "reference-resolvers": "/reference-resolvers/static-1.8013",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3791",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.188",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2851",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2318",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4920",
  "purchase-motions-components": "/purchase-motions-components/static-1.5555",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1401",
  "crm-component-utils": "/crm-component-utils/static-1.38599",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5723",
  "customer-data-properties": "/customer-data-properties/static-1.50925",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6723",
  "property-value-citations": "/property-value-citations/static-1.1539",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7933",
  "navigation-messaging": "/navigation-messaging/static-1.6764",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9592",
  "cms-field-types": "/cms-field-types/static-1.4659",
  "content-icons-ui": "/content-icons-ui/static-1.2174",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7098",
  "crm-message-bus": "/crm-message-bus/static-1.42512",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21515",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9674",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4571",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3879",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6628",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.825",
  "onboarding-tours": "/onboarding-tours/static-1.16336",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13201",
  "academy-common-lib": "/academy-common-lib/static-1.13191",
  "content-assistance-lib": "/content-assistance-lib/static-1.7521",
  "dashboard-lib": "/dashboard-lib/static-1.80831",
  "file-manager-components": "/file-manager-components/static-1.23050",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18020",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17740",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17732",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19557",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8543",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4617",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10779",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8882",
  "user-context": "/user-context/static-1.4950",
  "growth-payments-core": "/growth-payments-core/static-1.24868",
  "reporting-plugins": "/reporting-plugins/static-1.10040",
  "reporting-reports": "/reporting-reports/static-1.66408",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.575",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28966",
  "react-codemirror": "/react-codemirror/static-1.10476",
  "framework-listing-lib": "/framework-listing-lib/static-2-rr-react-compiler.25",
  "fuzzy": "/fuzzy/static-1.8",
  "apps-service-types": "/apps-service-types/static-1.3727",
  "oauth-service-types": "/oauth-service-types/static-1.4097",
  "onboarding-scopes": "/onboarding-scopes/static-1.6313",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4550",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7538",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14650",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3488",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8723",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4349",
  "nav-client-types": "/nav-client-types/static-1.2207",
  "purchase-motions-api": "/purchase-motions-api/static-1.5558",
  "signup-constants": "/signup-constants/static-1.18512",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7884",
  "trials-service-types": "/trials-service-types/static-1.3750",
  "card-properties-lib": "/card-properties-lib/static-1.43665",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36601",
  "crm-actions": "/crm-actions/static-1.6157",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43069",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8921",
  "customer-data-tracking": "/customer-data-tracking/static-1.6732",
  "hs-entities": "/hs-entities/static-1.533",
  "pulse": "/pulse/static-1.371",
  "calling-global-api": "/calling-global-api/static-1.63866",
  "calling-internal-common": "/calling-internal-common/static-1.31149",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65248",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57542",
  "commerce-products-lib": "/commerce-products-lib/static-1.8988",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3669",
  "crm-links": "/crm-links/static-1.6118",
  "external-options-client-types": "/external-options-client-types/static-1.4030",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4094",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.482",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3562",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48164",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3835",
  "smart-property-lib": "/smart-property-lib/static-1.6129",
  "tiered-pricing": "/tiered-pricing/static-1.907",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10843",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4011",
  "customer-data-associations": "/customer-data-associations/static-1.7173",
  "customer-data-views-management": "/customer-data-views-management/static-1.25094",
  "framework-data-table": "/framework-data-table/static-2.11535",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6694",
  "nudge-client-utils": "/nudge-client-utils/static-1.2264",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.770",
  "react-dnd-compat": "/react-dnd-compat/static-1.4470",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5209",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2922",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1426",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.402",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7377",
  "academy-service-client": "/academy-service-client/static-1.3530",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28076",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8233",
  "video-components-external": "/video-components-external/static-1.10726",
  "video-data-lib": "/video-data-lib/static-1.34384",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8409",
  "payment-link-components": "/payment-link-components/static-1.23071",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9737",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23991",
  "viral-links-lib": "/viral-links-lib/static-1.6888",
  "data-token-picker": "/data-token-picker/static-1.16128",
  "FileManagerLib": "/FileManagerLib/static-1.38690",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5094",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17138",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8431",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.242",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3031",
  "crm_data": "/crm_data/static-4.91410",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45549",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15247",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18629",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18085",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9921",
  "crm-fe-perf": "/crm-fe-perf/static-1.22755",
  "directed-graph": "/directed-graph/static-1.789",
  "event-emitter": "/event-emitter/static-1.797",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31155",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10889",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6391",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.392",
  "commerce-permissions": "/commerce-permissions/static-1.613",
  "products-iframe-lib": "/products-iframe-lib/static-1.7463",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9976",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5395",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9677",
  "policy-lib": "/policy-lib/static-1.6627",
  "react-tinymce": "/react-tinymce/static-1.54761",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9740",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53887",
  "tinymce-plugins": "/tinymce-plugins/static-1.57001",
  "tinymce-themes": "/tinymce-themes/static-1.55857",
  "crm-export-dialog": "/crm-export-dialog/static-1.6142",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6285",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1444",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2021",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2340",
  "whisper-core-api": "/whisper-core-api/static-1.6132",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14352",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1454",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6431",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11649",
  "content-media-compositions": "/content-media-compositions/static-2.15656",
  "media-bridge-lib": "/media-bridge-lib/static-1.18650",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5798",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4936",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3517",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21393",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3693",
  "audio-components": "/audio-components/static-1.5685",
  "FileManagerCore": "/FileManagerCore/static-1.38549",
  "FileManagerImages": "/FileManagerImages/static-1.36201",
  "video-components": "/video-components/static-1.12729",
  "crm_universal": "/crm_universal/static-1.21744",
  "customer-data-email": "/customer-data-email/static-1.17755",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36653",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39024",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11380",
  "customer-data-content": "/customer-data-content/static-1.26966",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54188",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20996",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17272",
  "project-storage": "/project-storage/static-1.4583",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71364",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5181",
  "utility-belt": "/utility-belt/static-1.2390",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22150",
  "customer-data-rte": "/customer-data-rte/static-1.32566",
  "cv-backend-services": "/cv-backend-services/static-1.1516",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5441",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4964",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37454",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35169",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2893",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39972",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5064",
  "layout-dnd-components": "/layout-dnd-components/static-1.12135",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11110",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14242",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8942",
  "deal-intel-utils": "/deal-intel-utils/static-1.1448",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4381",
  "video-embed": "/video-embed/static-1.35218",
  "social-insights-client-types": "/social-insights-client-types/static-1.21509",
  "sequences-lib": "/sequences-lib/static-1.7767",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10197",
  "products-ui-components": "/products-ui-components/static-1.39507",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80085",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8980",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6806",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54204",
  "commerce-products-api": "/commerce-products-api/static-1.2033",
  "SafeStorage": "/SafeStorage/static-1.4252",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56262",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102042",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7223",
  "draft-content-plugins": "/draft-content-plugins/static-1.27834",
  "ContentData": "/ContentData/static-1.67851",
  "layout-data-lib": "/layout-data-lib/static-1.9435",
  "outpost": "/outpost/static-1.4050",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7624",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.367",
  "property-description-translator": "/property-description-translator/static-1.3706",
  "FireAlarmUi": "/FireAlarmUi/static-1.4379",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4038",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3505",
  "totals-ui-components": "/totals-ui-components/static-1.23122",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14890",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11859",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33583",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3687",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14889",
  "simple-menus-lib": "/simple-menus-lib/static-1.16406"
}
};
